import { Reveal } from "./Reveal";

const POINTS = [
  {
    title: "Ponad 20 lat doświadczenia biznesowego",
    desc: "Handel, sprzedaż, zarządzanie, własne przedsiębiorstwa, franczyza i systemy agencyjne.",
  },
  {
    title: "Doświadczenie deweloperskie",
    desc: "Realizacja inwestycji budowlanych daje praktyczne spojrzenie na koszty, wykonawstwo i opłacalność projektu.",
  },
  {
    title: "Doświadczenie samorządowe",
    desc: "Jako były burmistrz znam proces inwestycyjny od strony administracji, planowania przestrzennego i funkcjonowania samorządu.",
  },
  {
    title: "Nieruchomości",
    desc: "Łączę wiedzę o rynku nieruchomości z analizą inwestycyjną i doświadczeniem biznesowym.",
  },
  {
    title: "Jeden partner — cały proces",
    desc: "Od znalezienia nieruchomości poprzez analizę i procedury aż do realizacji lub komercjalizacji projektu.",
  },
];

export const WhyMe = () => (
  <section id="dlaczego-ja" data-testid="why-me-section" className="bg-[#090D16] py-24 text-white lg:py-36">
    <div className="mx-auto grid max-w-7xl grid-cols-1 gap-14 px-4 sm:px-8 lg:grid-cols-12 lg:gap-20 lg:px-16">
      <Reveal className="lg:col-span-5">
        <div className="lg:sticky lg:top-32">
          <p className="mb-4 font-mono text-xs font-semibold uppercase tracking-[0.2em] text-[#D8B07C]">
            Dlaczego ja
          </p>
          <h2 className="font-serif text-2xl font-semibold leading-tight tracking-tight sm:text-3xl lg:text-4xl">
            Dlaczego warto ze mną pracować?
          </h2>
          <p className="mt-6 max-w-sm text-sm leading-relaxed text-white/60">
            Synergia doświadczenia biznesowego, deweloperskiego i samorządowego — trzy perspektywy
            jednego procesu inwestycyjnego.
          </p>
          <div className="relative mt-12 max-w-sm">
            <div className="absolute -left-4 -top-4 h-full w-full rounded-sm border border-[#D8B07C]/30" />
            <img
              src="/assets/portrait-suit.webp"
              alt="Janusz Błotnicki — Investment & Expansion Partner"
              data-testid="why-me-portrait-image"
              className="relative aspect-[4/5] w-full rounded-sm object-cover object-top"
            />
            <div className="absolute -bottom-6 -right-4 bg-[#8C6D46] px-7 py-5">
              <p className="font-serif text-lg italic leading-tight text-white">
                „Jeden partner —<br />cały proces."
              </p>
            </div>
          </div>
        </div>
      </Reveal>

      <div className="lg:col-span-7">
        {POINTS.map((p, i) => (
          <Reveal key={p.title} delay={0.06 * i}>
            <div
              data-testid={`why-me-point-${i + 1}`}
              className="group flex gap-6 border-b border-white/10 py-8 transition-colors duration-300 first:pt-0 hover:border-[#D8B07C]/40 sm:gap-10"
            >
              <span className="font-mono text-sm text-[#D8B07C]/70">0{i + 1}</span>
              <div>
                <h3 className="font-serif text-xl font-medium text-white sm:text-2xl">{p.title}</h3>
                <p className="mt-3 max-w-lg text-sm leading-relaxed text-white/60">{p.desc}</p>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
